import { LinkButtonStrapiProps } from '@/components/atoms/LinkButton/LinkStrapi';
import { BannerStrapiProps } from '@/components/atoms/banner/BannerStrapi';

export function normalizeBannerProps(block: BannerStrapiProps) {
  const rawButton = block.buttons?.[0];
  const normalizedButton: LinkButtonStrapiProps | undefined = rawButton
    ? {
        ...rawButton,
        variant: (rawButton.variant as any) ?? 'filled',
        color: (rawButton.color as any) ?? 'primary',
      }
    : undefined;

  return {
    ...block,
    button: normalizedButton,
  };
}
